import { inject, observer } from 'mobx-react';
import React from 'react';
import { CmsData, Environment, GravityForm as GravityFormComponent, GravityFormBaseProps } from '@teliaee/gravity-forms';
import config from '../config';
import LanguageStore from 'src/stores/LanguageStore';
import RouteStore from 'src/stores/RouteStore';
import SsoStore from 'src/stores/SsoStore';
import ContentStore from 'src/stores/ContentStore';

export interface GravityFormProps extends GravityFormBaseProps {
  languageStore?: LanguageStore;
  routeStore?: RouteStore;
  ssoStore?: SsoStore;
  contentStore?: ContentStore;
  cmsData?: CmsData[];
  app?: App;
}

const GravityForm = (props: GravityFormProps) => {
  const { languageStore, routeStore, ssoStore, contentStore, cmsData, app, ...rest } = props;

  return (
    <GravityFormComponent
      {...rest}
      language={languageStore.currentLanguage}
      env={(config.environment || 'live') as Environment}
      app={app}
      decodedParams={routeStore.decodedParams}
      navigate={routeStore.push}
      clientAuth={ssoStore.auth}
      pathname={routeStore.pathname}
      credentialsAllowed={config.credentialsAllowed}
      formsList={contentStore.formsList}
      cmsData={cmsData}
    />
  );
};

export default inject('languageStore', 'routeStore', 'ssoStore', 'contentStore', 'app')(observer(GravityForm));
